// @ts-strict-ignore
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { update as apiUpdate } from '../../api/classroom';
import { ClassroomResponse } from '../../../types/routes/classroom';
import { RejectedPayload, constructRejectedPayload } from './util';

export type UpdateClassroomArgs = {
  id: number | null;
  classIds: number[];
};

export const resetUpdate = createAction('classroom/update/reset');
export const update = createAsyncThunk<
  ClassroomResponse,
  UpdateClassroomArgs,
  {
    rejectValue: RejectedPayload;
  }
>('classroom/update', async (classToUpdate: UpdateClassroomArgs, { rejectWithValue }) => {
  try {
    return await apiUpdate(classToUpdate);
  } catch (error) {
    return rejectWithValue(constructRejectedPayload(error));
  }
});
